exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".backdrop{position:fixed;z-index:500;background:rgba(1,0,15,.8);top:0;right:0;bottom:0;left:0;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:start;-ms-flex-align:start;align-items:flex-start;padding:3rem 0;overflow-y:scroll;-webkit-overflow-scrolling:touch}@media (min-width:550px){.backdrop{padding-top:3rem}}@media screen and (max-height:440px){.backdrop{padding-top:1rem}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-03602dbe","scoped":false,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/vue/components/Backdrop.vue
// module id = 45
// module chunks = 0